/**
 * @generated SignedSource<<7f0a088976814ff0c4e5d7c286768f1f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type utilizationMonthlyComponentRefetchQuery$variables = {
  shareKey?: string | null;
  year?: number | null;
  selectValue?: string | null;
  componentId?: string | null;
  personIds?: ReadonlyArray<string | null> | null;
  teamIds?: ReadonlyArray<string | null> | null;
  roleIds?: ReadonlyArray<string | null> | null;
  labelIds?: ReadonlyArray<string | null> | null;
  projectStatusesBackend?: ReadonlyArray<string | null> | null;
};
export type utilizationMonthlyComponentRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"utilizationMonthlyComponent_viewer">;
  } | null;
};
export type utilizationMonthlyComponentRefetchQuery = {
  variables: utilizationMonthlyComponentRefetchQuery$variables;
  response: utilizationMonthlyComponentRefetchQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "componentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "labelIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "personIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectStatusesBackend"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "roleIds"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "selectValue"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shareKey"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamIds"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "year"
},
v9 = {
  "kind": "Variable",
  "name": "componentId",
  "variableName": "componentId"
},
v10 = {
  "kind": "Variable",
  "name": "labelIds",
  "variableName": "labelIds"
},
v11 = {
  "kind": "Variable",
  "name": "personIds",
  "variableName": "personIds"
},
v12 = {
  "kind": "Variable",
  "name": "projectStatusesBackend",
  "variableName": "projectStatusesBackend"
},
v13 = {
  "kind": "Variable",
  "name": "roleIds",
  "variableName": "roleIds"
},
v14 = {
  "kind": "Variable",
  "name": "selectValue",
  "variableName": "selectValue"
},
v15 = {
  "kind": "Variable",
  "name": "shareKey",
  "variableName": "shareKey"
},
v16 = {
  "kind": "Variable",
  "name": "teamIds",
  "variableName": "teamIds"
},
v17 = {
  "kind": "Variable",
  "name": "year",
  "variableName": "year"
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jan",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feb",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mar",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "apr",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "may",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jun",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jul",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aug",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sep",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oct",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nov",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dec",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "janBillable",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "febBillable",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "marBillable",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aprBillable",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mayBillable",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "junBillable",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "julBillable",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "augBillable",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sepBillable",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "octBillable",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "novBillable",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "decBillable",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "utilizationMonthlyComponentRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "utilizationMonthlyComponent_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v6/*: any*/),
      (v8/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v7/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "utilizationMonthlyComponentRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              (v15/*: any*/)
            ],
            "concreteType": "InsightComponentsDataType",
            "kind": "LinkedField",
            "name": "insightComponentsData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/)
                ],
                "concreteType": "UtilizationMonthly",
                "kind": "LinkedField",
                "name": "utilizationMonthly",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v38/*: any*/),
                  (v39/*: any*/),
                  (v40/*: any*/),
                  (v41/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UtilizationPerson",
                    "kind": "LinkedField",
                    "name": "people",
                    "plural": true,
                    "selections": [
                      (v42/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "profilePictureId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "profilePictureDefaultId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "role",
                        "storageKey": null
                      },
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v26/*: any*/),
                      (v27/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v33/*: any*/),
                      (v34/*: any*/),
                      (v35/*: any*/),
                      (v36/*: any*/),
                      (v37/*: any*/),
                      (v38/*: any*/),
                      (v39/*: any*/),
                      (v40/*: any*/),
                      (v41/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v42/*: any*/)
                ],
                "storageKey": null
              },
              (v42/*: any*/)
            ],
            "storageKey": null
          },
          (v42/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a510ba38d83016f9a14a3267fe76a4e3",
    "id": null,
    "metadata": {},
    "name": "utilizationMonthlyComponentRefetchQuery",
    "operationKind": "query",
    "text": "query utilizationMonthlyComponentRefetchQuery(\n  $shareKey: String\n  $year: Int\n  $selectValue: String\n  $componentId: ID\n  $personIds: [ID]\n  $teamIds: [ID]\n  $roleIds: [ID]\n  $labelIds: [ID]\n  $projectStatusesBackend: [ID]\n) {\n  viewer {\n    ...utilizationMonthlyComponent_viewer_3hjJhe\n    id\n  }\n}\n\nfragment utilizationMonthlyComponent_viewer_3hjJhe on Viewer {\n  insightComponentsData(shareKey: $shareKey) {\n    utilizationMonthly(year: $year, selectValue: $selectValue, personIds: $personIds, roleIds: $roleIds, teamIds: $teamIds, componentId: $componentId, labelIds: $labelIds, projectStatusesBackend: $projectStatusesBackend) {\n      jan\n      feb\n      mar\n      apr\n      may\n      jun\n      jul\n      aug\n      sep\n      oct\n      nov\n      dec\n      janBillable\n      febBillable\n      marBillable\n      aprBillable\n      mayBillable\n      junBillable\n      julBillable\n      augBillable\n      sepBillable\n      octBillable\n      novBillable\n      decBillable\n      people {\n        id\n        profilePictureId\n        profilePictureDefaultId\n        firstName\n        lastName\n        role\n        jan\n        feb\n        mar\n        apr\n        may\n        jun\n        jul\n        aug\n        sep\n        oct\n        nov\n        dec\n        janBillable\n        febBillable\n        marBillable\n        aprBillable\n        mayBillable\n        junBillable\n        julBillable\n        augBillable\n        sepBillable\n        octBillable\n        novBillable\n        decBillable\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d224dc3c291e25cc02d17e78d2c15741";

export default node;
